/*
 * A faixa de arte do card de experiência, em um lugar só.
 *
 * Duas telas desenham o MESMO card: o do catálogo (`ExperienceSelectCard`), onde o jogador
 * escolhe, e o da página de feedback, onde ele vê o que escolheu e pode cancelar. Os
 * números viviam só no primeiro; o segundo recortava a arte com `object-cover` e uma altura
 * fixa, e os dois cards mostravam o mesmo item de jeitos diferentes.
 *
 * Ficam aqui porque a proporção é a única coisa que os dois PRECISAM ter igual: mudar a
 * arte de lugar num arquivo e esquecer o outro é o modo de falha que esta feature já viu
 * três vezes com texto.
 */

// Proporção da faixa de imagem, tirada da arte real.
//
// As 31 artes do 1S2026 são todas 802×424 (proporção 1,89). Fixar a PROPORÇÃO em vez da
// altura acaba com a sobra de fundo acima e abaixo da arte e sobrevive a mudança de largura
// do card, que uma altura em pixels não acompanharia.
export const ART_WIDTH_PX = 802;
export const ART_HEIGHT_PX = 424;

// Piso em pixels, para o caso de `aspect-ratio` não ser suportado.
//
// Sem ele, um navegador que ignora a propriedade deixaria a faixa com altura automática — e
// como a `<img>` usa `h-full`, as duas se anulariam em zero e a arte sumiria. O valor é a
// altura que a proporção produz na largura atual (300px), então onde `aspect-ratio` vale,
// este piso nunca é alcançado.
export const IMAGE_BAND_MIN_HEIGHT_PX = 156;
